export const REPLY_INPUT_MESSAGE = 'REPLY/INPUT/MESSAGE'
export const REPLY_INPUT_TITLE = 'REPLY/INPUT/TITLE'

export const REPLY_STATUS_WAITING = 'REPLY/STATUS/WAITING'
export const REPLY_STATUS_PROCESSING = 'REPLY/STATUS/PROCESSING'
export const REPLY_STATUS_SUCCESS = 'REPLY/STATUS/SUCCESS'
export const REPLY_STATUS_FAILED = 'REPLY/STATUS/FAILED'

